import { Flex, SignLeftSide, SignRightSide, Text } from '@/src/ui-components';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/src/ui-components/ui/dialog';
import { SignInForm } from './components';
import { useState } from 'react';

export default function SignInPage() {
  const [isInvitationDialogOpen, setIsInvitationDialogOpen] = useState(false);

  const handleGetInvitation = () => {
    setIsInvitationDialogOpen(true);
  };

  return (
    <div className="flex min-h-screen pb-4">
      {/* Left Side - Background Image */}
      <SignLeftSide>
        <Flex className="relative h-full w-full">
          <img
            src="/bg.png"
            alt=""
            className="absolute inset-0 h-full w-full object-cover"
          />
          {/* Overlay Text */}
          <div className="relative z-10 flex flex-col justify-center h-full w-full px-12 text-left text-white">
            <h1 className="text-6xl font-bold mb-6 leading-tight">
              Institutional Digital<br />Asset Management
            </h1>
            <div className="text-xl space-y-2">
              <p>Multi-Asset Investing</p>
              <p>Spot & Derivatives Trading</p>
              <p>Market Making & Liquidity | Staking | Wallet & Custody</p>
            </div>
          </div>
        </Flex>
      </SignLeftSide>

      {/* Right Side - Form */}
      <SignRightSide>
        <SignRightSide.Title className="flex-col flex-wrap lg:flex-row">
          {/* Zerocap Logo */}
          <Flex justify="center" className="mb-8 w-full">
            <img
              src="/zerocap-logo.svg"
              alt="Zerocap"
              className="h-12 object-contain"
            />
          </Flex>
          {/* Title */}
          <Text size="3xl" weight="bold">
            Sign In
          </Text>
          <Text size="base" weight="normal">
            Enter your credentials to access your account
          </Text>
        </SignRightSide.Title>

        <SignRightSide.Body className="align-stretch">
          <SignInForm />
        </SignRightSide.Body>

        <SignRightSide.Footer
          linkDescription="Don't have an account yet? "
          linkText="Get an invitation!"
          onClick={handleGetInvitation}
        />
      </SignRightSide>

      <Dialog open={isInvitationDialogOpen} onOpenChange={setIsInvitationDialogOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Invitation Required</DialogTitle>
            <DialogDescription>
              Please contact Zerocap Support to get an invitation to the Dex.
            </DialogDescription>
          </DialogHeader>
        </DialogContent>
      </Dialog>
    </div>
  );
}
